<h1 mat-dialog-title>{{ isLoaded ? "Select" : "Loading" }} Source of MoI</h1>
<div mat-dialog-content style="min-height: 200px">
    @if (isLoaded) {
        <div>
            @if (!hideIncidentMoiOption) {
                <div class="cerrix-banner" [class]="type">
                    <span>Incident MOI's can be created from the incidents detail page</span>
                </div>
            }
            <ng-select
                data-uiid="moi-sourceselector-select"
                [items]="moiSources"
                bindLabel="Value"
                bindValue="Key"
                [(ngModel)]="selectedSource"
                placeholder="Select moi type"
                (change)="setSourceData()"
                [clearable]="false"
            >
            </ng-select>
            <input
                class="form-control text-center my-2"
                [(ngModel)]="textFilter"
                (debounce-input-event)="filterData()"
                placeholder="Search / filter"
                [disabled]="!allData || allData.length == 0"
                inputTooltip
            />
            @if (allData && allData.length > 0 && filteredData && filteredData.length > 0) {
                <table
                    data-uiid="moi-sourceselector-table"
                    class="cerrix-table moi-source-table bordered hoverable striped rounded"
                >
                    <thead>
                        <tr>
                            @for (column of columnInfo; track column) {
                                <th
                                    (click)="setSort(column.renderer.textColumn)"
                                    [style.width]="column.renderer.columnWidth + 'px'"
                                >
                                    {{ column.header }}
                                    @if (column.renderer.textColumn == sortColumn) {
                                        <i
                                            class="fas fa-sort-amount-{{ sortAsc ? 'down' : 'up' }}"
                                        ></i>
                                    }
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of currentData; track row) {
                            <tr
                                data-uiid="moi-sourceselector-table-row"
                                [class.highlighted]="selectedGuid == row[sourceGuidColumn]"
                                (click)="selectedGuid = row[sourceGuidColumn]"
                            >
                                @for (column of columnInfo; track column) {
                                    <td class="text-truncate">
                                        <workspace-cell
                                            [renderer]="column.renderer"
                                            [row]="row"
                                            [width]="column.renderer.columnWidth"
                                        ></workspace-cell>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            } @else {
                <div class="text-center mt-2">No data found matching source and filter(s).</div>
            }

            @if (filteredData && filteredData.length > 0) {
                <nav class="mt-2" aria-label="source-table-navigation">
                    <ul class="pagination justify-content-center">
                        <li
                            class="page-item"
                            [class.disabled]="currentPage == 0"
                            (click)="setPagination(currentPage - 1)"
                        >
                            <span class="page-link" aria-label="Previous">Previous</span>
                        </li>
                        <li class="page-item disabled">
                            <span class="page-link"
                                >Page {{ currentPage + 1 }} of {{ pageCount }}</span
                            >
                        </li>
                        <li
                            class="page-item"
                            [class.disabled]="currentPage == pageCount - 1"
                            (click)="setPagination(currentPage + 1)"
                        >
                            <span class="page-link" aria-label="Next">Next</span>
                        </li>
                    </ul>
                </nav>
            }
        </div>
    } @else {
        <div class="fancy-loader"></div>
    }
</div>
@if (isLoaded) {
    <div mat-dialog-actions style="justify-content: flex-end">
        <button mat-raised-button (click)="close(true)">
            <i class="fas fa-times"></i>
            <span class="d-none d-lg-inline ms-2">Close</span>
        </button>
        <button
            data-uiid="moi-sourceselector-linksource"
            mat-raised-button
            color="primary"
            (click)="close()"
            [disabled]="!selectedGuid"
        >
            <i class="fas fa-link"></i>
            <span class="d-none d-lg-inline ms-2">Link source</span>
        </button>
    </div>
}
